export const resumeTiers = [
  {
    id: 'basic',
    name: 'Basic',
    price: '$800',
    audience: 'Early-career professionals and technical specialists building foundational positioning',
    focus: 'Professional presentation and clarity, rather than deep strategic branding.',
    scope: [
      'Resume formatting overhaul for a modern, clean, and professional visual structure',
      'Editing for grammar, tone, and clarity to improve readability and flow',
      'Refinement of job descriptions to better articulate responsibilities and contributions',
      'Identification of measurable accomplishments where readily derived',
      'Professional summary introducing your career direction',
    ],
    value:
      'A polished, professionally formatted resume that strengthens credibility and organization for early professional growth.',
    revisions: '1 structured revision round',
    featured: false,
  },
  {
    id: 'standard',
    name: 'Standard',
    price: '$1,000',
    audience: 'Mid-level managers, senior specialists, and emerging leaders moving into broader leadership roles',
    focus: 'Introduces positioning strategy and stronger impact communication.',
    scope: [
      'Full restructuring and creation of content emphasizing leadership, ownership, and results over task lists',
      'Achievement-focused bullets highlighting performance, efficiencies, cost savings, and team leadership',
      'Stronger professional profile aligned with management and senior management expectations',
      'Industry-relevant keywords for competitive and ATS positioning',
      'Clear articulation of cross-functional collaboration and decision-making authority',
    ],
    value:
      'A leadership-oriented resume that presents you as a results-driven manager, ready for director-track and senior management opportunities.',
    revisions: '2 structured revision rounds',
    featured: false,
  },
  {
    id: 'premium',
    name: 'Premium Executive',
    price: '$1,300',
    audience: 'Senior Directors, Vice Presidents, C-suite advisors, and board-level or enterprise leaders',
    focus: 'A comprehensive executive branding engagement.',
    scope: [
      'Complete strategic rebuild reflecting enterprise-level leadership, not a chronological history',
      'Compelling executive narrative communicating scope of authority, scale of operations, and strategic influence',
      'Emphasis on high-level impact: capital oversight, regulatory accountability, risk management, and mission-critical operations',
      'Executive branding summary defining your leadership identity, value proposition, and market positioning',
      'Career history reframed to show progression of responsibility and executive-level decision-making',
      'Language and structure aligned with executive search firms, boards, and sector expectations — including hyperscale data center and critical infrastructure leadership',
    ],
    value:
      'A board-ready, executive-caliber resume that reflects your true professional altitude for senior leadership and advisory opportunities.',
    revisions: '3 structured revision rounds with consultative feedback',
    featured: true,
  },
]

export const projectProcess = [
  {
    title: 'Dedicated development',
    description: 'Up to 24 hours invested in research, writing, structuring, and executive positioning.',
  },
  {
    title: 'Focused first draft',
    description: 'Your initial draft is delivered within a focused production window following information intake.',
  },
  {
    title: '2-day revision turnaround',
    description: 'Each revision is returned within two business days of receiving your feedback.',
  },
  {
    title: 'Open communication',
    description: 'Ongoing dialogue for clarification and refinement until the document powerfully represents you.',
  },
]
